import type { RulesRepository } from '@/diagnostic/domain/RulesRepository.ts';
import { type Rule, type RulesRepository as RuleRulesRepository } from '@/rule';
import type { Page, Pagination } from '@/generic/pagination';

export class RulesRepositoryRule implements RulesRepository {
  readonly #ruleRulesRepository: RuleRulesRepository;

  constructor(ruleRulesRepository: RuleRulesRepository) {
    this.#ruleRulesRepository = ruleRulesRepository;
  }

  async listActive(pagination: Pagination): Promise<Page<Rule>> {
    return this.#ruleRulesRepository.listActive(pagination);
  }
}
